import {
    PAGE_HEADER_NAME,
   } from "./actionType";
   
   // common success
   export const StorePageHeaderName = (pageName) => ({
     type: PAGE_HEADER_NAME,
     payload:pageName,
   });
  